import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IoAddOutline } from "react-icons/io5";

const AddButton = ({ label = "Add", onClick = () => {}, disabled = false, loading = false }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(label)}>
      <span>
        <IconButton onClick={onClick} disabled={disabled || loading} variant="Light Green">
          {loading ? <CircularProgress size={18} sx={{ color: "inherit" }} /> : <IoAddOutline />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default AddButton;
